import { SegmentedControl } from "@/components/ui/segmented-control";
import type { BillingInterval } from "../data";

interface BillingToggleProps {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
  disabled?: boolean;
}

export function BillingToggle({
  value,
  onChange,
  disabled,
}: BillingToggleProps) {
  return (
    <SegmentedControl<BillingInterval>
      value={value}
      onValueChange={onChange}
      disabled={disabled}
      aria-label="Billing interval"
      options={[
        { value: "monthly", label: "Monthly" },
        {
          value: "annual",
          label: "Annual",
          badge: (
            <span className="rounded-full bg-brand-tint px-2 py-0.5 text-xs font-medium text-brand-strong">
              Save 17%
            </span>
          ),
        },
      ]}
    />
  );
}
